<template>
	<inertia-head title="Bo Sanchez FREE Investor Zoom" />
	<div class="content pt-0">
		<div v-if="investorZoomEvent && zoom_access" class="row justify-content-center">
			<div class="col-sm-12 col-md-10 col-lg-8">
				<img :src="investorZoomEvent.investor_zoom_img" alt="" class="img-fluid mb-2">
			</div>
			<div class="col-sm-12 col-md-10 col-lg-8">
				<div v-if="zoom_access.time_limit<=10800">
					<div v-if="zoom_access.end_time_limit<=0" class="mt-3 h5 text-center">
	                    <p class="h2 mb-4">That session has already concluded. Please join us for the next scheduled Zoom session.</p>
	                    <!-- <div class="form-group mb-3 mt-5">
							<label>Choose a Zoom Session</label>
							<select v-model="form.zoom_datetime" id="zoom_datetime" name="zoom_datetime" class="form-select">
								<option value=""></option>
								<option v-for="(zdate,z_index) in investorZoomEvent.zoom_dates" :value="zdate.investor_zoom_date_uuid+'|'+zdate.start_datetime+'|'+zdate.end_datetime">{{zdate.start_date_format}} from {{zdate.start_time}} - {{zdate.end_time}}</option>
							</select>
							<span v-if="form.errors.zoom_datetime" class="text-danger">{{form.errors.zoom_datetime}}</span>
						</div> -->

						<div class="form-group mb-3 mt-5">
							<h3>{{investorZoomEvent.zoom_dates ? investorZoomEvent.zoom_dates.start_date_format + " from " + investorZoomEvent.zoom_dates.start_time + " - " + investorZoomEvent.zoom_dates.end_time + ' PST(GMT+8)': 'No Available Zoom Session'}}</h3>
						</div>
						<div v-if="investorZoomEvent.zoom_dates" class="form-group mt-4 text-center">
							<button @click="registerZoomNextSched" type="button" class="btn btn-success btn-lg" :disabled="form.processing">
							<div
								v-if="form.processing"
								class="spinner-border spinner-border-sm text-white me-1"
								role="status"
								>
								<span class="sr-only">Loading...</span>
							</div>
							<i v-else class="fa fa-plus me-1"></i>
							Register Now!
							</button>
						</div>
	                </div>
					<div v-else class="mt-3 h4 text-center">
	                    <p class="h2 mt-3 mb-3">{{investorZoomEvent.investor_zoom_topic}}</p>
	                    <div>{{zoom_access.start_date_format}} from {{zoom_access.start_time_format}} - {{zoom_access.end_time_format}} PST(GMT+8)</div>
	                    <hr/>
	                    <p class="h3 mb-2">Join Zoom Meeting</p>
	                    <p class="mb-1">Meeting ID: {{zoom_access.zoom_meeting_id}}</p>
	                    <p class="mb-1">Passcode: {{zoom_access.zoom_passcode}}</p>
	                    <p class="mt-3">
	                        <a @click="clickZoomAccess(zoom_access.zoom_access_code)" :href="zoom_access.zoom_access_url" class="btn btn-lg btn-success" target="_blank">Click Here to Join</a>
	                    </p>
	                </div>
                </div>
				<div v-else class="mb-5 h4 text-center">
                    <p class="h2 mt-4 mb-3">{{investorZoomEvent.investor_zoom_topic}}</p>
                    <div>{{zoom_access.start_date_format}} from {{zoom_access.start_time_format}} - {{zoom_access.end_time_format}} PST(GMT+8)</div>
                    <hr/>
                    <div class="row text-center">
                        <div class="col-6 col-md-3 mt-3">
                            <div id="days" class="h1 text-bold text-black"></div>
                            <div class="text-black-50">DAYS</div>
                        </div>
                        <div class="col-6 col-md-3 mt-3">
                            <div id="hrs" class="h1 text-bold text-black"></div>
                            <div class="text-black-50">HOURS</div>
                        </div>
                        <div class="col-6 col-md-3 mt-3">
                            <div id="mins" class="h1 text-bold text-black"></div>
                            <div class="text-black-50">MINUTES</div>
                        </div>
                        <div class="col-6 col-md-3 mt-3">
                            <div id="secs" class="h1 text-bold text-black"></div>
                            <div class="text-black-50">SECONDS</div>
                        </div>
                    </div>
                </div>
			</div>
		</div>
		<div v-else class="row justify-content-center">
			<error :error="404"/>
		</div>
	</div>

	<!-- Footer -->
	<footer id="page-footer">
		<div class="content py-3">
			<div class="row fs-sm">
				<div class="col-sm-12 order-sm-1 py-1 text-center">
					<a class="fw-semibold" href="#!">{{ $page.props.app.name }}</a>
					&copy; {{ $page.props.app.year }}
				</div>
			</div>
		</div>
	</footer>

</template>

<script>
	import GuestLayout from '../Layouts/GuestLayout';
	import { watch, ref, onMounted } from 'vue';
	import { useForm } from '@inertiajs/inertia-vue3';
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: GuestLayout,
		props:{
			flash 				: Object,
			errors 				: Object,
			zoom_access 		: Object,
			investorZoomEvent	: Object,
		},
		mounted(){
			this.countDown();
		},
		setup(props){

			const time_limit = ref(props.zoom_access ? props.zoom_access.time_limit : 0);

			const form = useForm({
				investor_zoom_event_uuid 	: (props.investorZoomEvent ? props.investorZoomEvent.investor_zoom_event_uuid : ''),
				zoom_access_code 			: (props.zoom_access ? props.zoom_access.zoom_access_code : ''),
				zoom_datetime 				: '',
			});

			const countDown = ()=>{
		        let days=0,hrs=0,mins=0,secs=0;
		        let days_display    = document.getElementById('days');
		        let hrs_display     = document.getElementById('hrs');
		        let mins_display    = document.getElementById('mins');
		        let secs_display    = document.getElementById('secs');
		        let timer           = null;

		        let self            =  this;

		        clearTimeout(timer);

		        if (time_limit.value>=10800) {

		            days    = Math.floor(time_limit.value/60/60/24);
		            hrs     = Math.floor(time_limit.value/60/60);
		            mins    = Math.floor(time_limit.value/60);
		            secs    = time_limit.value;

		            secs    = secs % 60;
		            mins    = mins % 60;
		            hrs     = hrs % 24;
		            days    = days;

		            days_display.innerHTML  = (days>9 ? days : "0" + days);
		            hrs_display.innerHTML   = (hrs>9 ? hrs : "0" + hrs);
		            mins_display.innerHTML  = (mins>9 ? mins : "0" + mins);
		            secs_display.innerHTML  = (secs>9 ? secs : "0" + secs);

		            timer = setTimeout(function(){

		                if(time_limit.value<=10800)
		                {
		                    window.location.reload();
		                    return false;
		                }

		                time_limit.value--;
		                
		                countDown();

		            },1000);
		        }
		    };

		    const clickZoomAccess = (_zoom_access_code)=>{
		    	form.put("click/"+_zoom_access_code,{
					only:['errors']
				});
		    }

		    const registerZoomNextSched = ()=>{

		    	form.zoom_datetime = props.investorZoomEvent ? (props.investorZoomEvent.zoom_dates ? props.investorZoomEvent.zoom_dates.investor_zoom_date_uuid+"|"+props.investorZoomEvent.zoom_dates.start_datetime+"|"+props.investorZoomEvent.zoom_dates.end_datetime : '') : '';

				form.post(route("post.investor-zoom-next-session"),{
					only:['flash','errors','investorZoomEvent'],
					onSuccess:(res)=>{
						if(res.props.flash.toast.type=='success')
						{
							form.zoom_datetime ='';
						}
					}
				});
			};

			watch(
				() => props.flash,
				(flash) => {
					if (flash && flash.toast) {
						if(flash.toast.type=='success')
						{
							Inertia.get("/c/investor/thankyou/"+flash.toast.data.attendee_uuid);
						}

					}
				}
			)

		    return{
		    	form,
		    	time_limit,
		    	countDown,
		    	clickZoomAccess,
		    	registerZoomNextSched
		    }
		}
	}
</script>